export const GOOGLE_WALLET_SAVE_URL = "https://pay.google.com/gp/t/savecard"
export const GOOGLE_WALLET_PROVISIONING_SOURCE = "web"

export const APPLE_WALLET_SCRIPT_PATH = "vendor/apple-wallet/apple.js"
export const APPLE_WALLET_STATE_RANGE = 10000000000

export const APPLE_WALLET_RESULT_STATUS = {
    SUCCESS: "200",
    DISMISSED: "444",
    TIMEOUT: "408",
    UNSUPPORTED_BROWSER: "40101"
}

export const GOOGLE_IDENTITY_SCRIPT_URL = "https://accounts.google.com/gsi/client"
export const WALLET_PENDING_PASS_STORAGE_KEY = "wallet.pendingGooglePassId"
export const WALLET_PENDING_SAVE_URL_STORAGE_KEY = "wallet.pendingGoogleSaveUrl"

export const WALLET_MESSAGES = {
    SUCCESS: "The access has been successfully granted to your wallet",
    IN_PROGRESS: "Your pass is being added to your wallet. It may take a few minutes to show as active.",
    NOT_ADDED_YET: "This pass isn't added to your wallet yet. If you didn't finish adding it, ask your property manager to issue a new one.",
    GOOGLE_NOT_DETECTED: "We couldn't see the pass in Google Wallet yet. Save it on your phone and press Continue again.",
    NO_PASS: "You don't have a building pass for this property yet.",
    TOKEN_EXPIRED: "This pass has expired. Ask your property manager to issue it again.",
    ALREADY_ADDED: "This pass has already been added to a device.",
    WALLET_NOT_SUPPORTED: "This pass can't be added to that wallet.",
    TOO_MANY_WALLETS: "You already have this pass on another device.",
    UNSUPPORTED_DEVICE: "This device can't hold a building pass.",
    DISMISSED: "The pass wasn't added. Ask your property manager to issue it again.",
    IN_APP_BROWSER: "Open this page in Safari or Chrome to add your pass.",
    GENERIC_ERROR: "We couldn't add your pass. Please try again."
}
